import React from 'react';

interface Props {
  children: React.ReactNode;
  /** Changing this value resets the boundary (e.g. the current route path). */
  resetKey?: string;
}
interface State {
  error: Error | null;
}

/**
 * Catches render errors in a single view so one broken screen can never blank
 * the entire app. Resets automatically when the route (resetKey) changes.
 */
class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('View crashed:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="main-content" style={{ textAlign: 'center', paddingTop: 'var(--spacing-xl)' }}>
          <h2 style={{ fontSize: '1.4rem', fontWeight: 700, marginBottom: '8px' }}>
            This screen hit a snag
          </h2>
          <p className="text-secondary" style={{ marginBottom: 'var(--spacing-lg)' }}>
            Something went wrong rendering this page. The rest of the app is still running.
          </p>
          <button
            onClick={() => this.setState({ error: null })}
            className="btn btn-glass"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
